import { axiosInstance } from '../common';

const ENDPOINT = `/message`;

export const getChatHistory = (token, itemId) => axiosInstance.get(ENDPOINT, {
    params: {
        token,
        item_id: itemId
    }
}).then(({ data }) => data)

export const sendChatMessage = (token, message, itemId) => axiosInstance.post(ENDPOINT, {
    message,
    item_id: itemId
}, {
    params: {
        token
    }
}).then(({ message: responseMessage }) => responseMessage)
